export class AppUserInterfaceFactory {
  createConfig() {}
}
